// extracted by mini-css-extract-plugin
export var footer = "_ko-0";
export var inherit = "_ko-1";
export var input = "_ko-2";
export var modalContent = "_ko-3";
export var quillEditor = "_ko-4";
export var subtitle = "_ko-5";